// AdminPanel.jsx
import React, { useEffect, useState,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Adminka.css';
import { io } from 'socket.io-client';

// === один раз, вне компонента ===
const API_ORIGIN = (
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' ? window.location.origin : '')
).replace(/\/+$/, '');

const api = axios.create({ baseURL: `${API_ORIGIN}/api` });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

function formatPresenceStatus(presence) {
  if (presence?.isOnline) {
    return 'Онлайн';
  }

  /*
   * Важно: Number(null) равен 0.
   * Из-за этого пользователи без истории раньше
   * ошибочно показывались как «был менее минуты назад».
   */
  if (
    !presence ||
    presence.secondsAgo == null
  ) {
    return 'Ещё не заходил';
  }

  const secondsAgo = Number(
    presence.secondsAgo
  );

  if (
    !Number.isFinite(secondsAgo) ||
    secondsAgo < 0
  ) {
    return 'Ещё не заходил';
  }

  if (secondsAgo < 60) {
    return 'Был менее минуты назад';
  }

  if (secondsAgo < 60 * 60) {
    const minutes = Math.floor(
      secondsAgo / 60
    );

    return `Был ${minutes} мин. назад`;
  }

  if (secondsAgo < 24 * 60 * 60) {
    const hours = Math.floor(
      secondsAgo / (60 * 60)
    );

    return `Был ${hours} ч. назад`;
  }

  const days = Math.floor(
    secondsAgo / (24 * 60 * 60)
  );

  return `Был ${days} дн. назад`;
}

function getPresenceBadgeStyle(isOnline) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    padding: '5px 9px',
    borderRadius: 999,
    fontSize: 13,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    color: isOnline ? '#166534' : '#475569',
    background: isOnline
      ? '#dcfce7'
      : '#f1f5f9',
    border: isOnline
      ? '1px solid #86efac'
      : '1px solid #cbd5e1',
  };
}

function AdminPanel() {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [presenceByUserId, setPresenceByUserId] = useState({});
  const [presenceLoading, setPresenceLoading] = useState(false);
  const [presenceError, setPresenceError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [role, setRole] = useState('');
  const [activeTab, setActiveTab] = useState('users');

  // ---------- BOT CONTROL CENTER (SHORT ONLY) ----------
  const [botSettingsPayload, setBotSettingsPayload] = useState(null);
  const [botConfig, setBotConfig] = useState(null);
  const [botSettingsLoading, setBotSettingsLoading] = useState(false);
  const [botSettingsSaving, setBotSettingsSaving] = useState(false);
  const [botSettingsError, setBotSettingsError] = useState('');


  // ---------- БАННЕРЫ ----------
const [siteBanners, setSiteBanners] = useState([]);

const [bannerName, setBannerName] = useState('');
const [bannerImageUrl, setBannerImageUrl] = useState('');
const [bannerLinkUrl, setBannerLinkUrl] = useState('');
const [bannerButtonText, setBannerButtonText] = useState('');
const [bannerIsActive, setBannerIsActive] = useState(true);

const [bannerUploading, setBannerUploading] = useState(false);
const [bannerSaving, setBannerSaving] = useState(false);
const [bannerError, setBannerError] = useState('');

  const [supportUnreadById, setSupportUnreadById] = useState({}); // { [threadId]: number }


    // ---------- Поддержка (чаты игроков) ----------
  const [supportThreads, setSupportThreads] = useState([]);        // список всех тредов
  const [supportLoadingThreads, setSupportLoadingThreads] = useState(false);
  const [supportThreadsError, setSupportThreadsError] = useState('');

  const [supportActiveThread, setSupportActiveThread] = useState(null); // выбранный тред
  const [supportMessages, setSupportMessages] = useState([]);           // сообщения выбранного треда
  const [supportLoadingMessages, setSupportLoadingMessages] = useState(false);
  const [supportNewText, setSupportNewText] = useState('');             // текст ответа админа
  const [supportSending, setSupportSending] = useState(false);

  // Поиск игрока, чтобы админ мог первым начать диалог.
  const [supportSearchText, setSupportSearchText] = useState('');
  const [supportSearchResults, setSupportSearchResults] = useState([]);
  const [supportSearchLoading, setSupportSearchLoading] = useState(false);
  const [supportSearchError, setSupportSearchError] = useState('');


  // ---------- КОРОТКИЕ КЕШ-ИГРЫ ----------
  const [shortGames, setShortGames] = useState([]);
  const [shortTotals, setShortTotals] = useState(null);      // 🆕 итоги за период
  const [isLoadingShortGames, setIsLoadingShortGames] = useState(false);
  const [shortGamesError, setShortGamesError] = useState('');

  // фильтры по датам (формат YYYY-MM-DD для input type="date")
  const [shortFrom, setShortFrom] = useState('');            // 🆕 дата "С"
  const [shortTo, setShortTo] = useState('');                // 🆕 дата "По"


    // ---------- ДЛИННЫЕ КЕШ-ИГРЫ ----------
  const [longGames, setLongGames] = useState([]);
  const [longTotals, setLongTotals] = useState(null);
  const [isLoadingLongGames, setIsLoadingLongGames] = useState(false);
  const [longGamesError, setLongGamesError] = useState('');

  const [longFrom, setLongFrom] = useState('');
  const [longTo, setLongTo] = useState('');




const [tournaments, setTournaments] = useState([]);
const [tournamentTotals, setTournamentTotals] = useState(null);
const [tournamentFrom, setTournamentFrom] = useState('');
const [tournamentTo, setTournamentTo] = useState('');
const [isLoadingTournaments, setIsLoadingTournaments] = useState(false);





const [longTournaments, setLongTournaments] = useState([]);
const [longTournamentTotals, setLongTournamentTotals] = useState(null);
const [longTournamentFrom, setLongTournamentFrom] = useState('');
const [longTournamentTo, setLongTournamentTo] = useState('');
const [isLoadingLongTournaments, setIsLoadingLongTournaments] = useState(false);




  // ---------- ПОКЕР: РЕЙК ПО ДНЯМ ----------
  const [pokerRakeRows, setPokerRakeRows] = useState([]);
  const [pokerRakeTotal, setPokerRakeTotal] = useState(0);
  const [pokerRakeFrom, setPokerRakeFrom] = useState('');
  const [pokerRakeTo, setPokerRakeTo] = useState('');
  const [isLoadingPokerRake, setIsLoadingPokerRake] = useState(false);
  const [pokerRakeError, setPokerRakeError] = useState('');

  // по лимитам столов (блайнды/бай-ины)
  const [pokerRakeByLimits, setPokerRakeByLimits] = useState([]);
  const [pokerRakeTotalHands, setPokerRakeTotalHands] = useState(0);


  // ---------- Ввод / вывод ----------
  const [finTxRows, setFinTxRows] = useState([]);
  const [finTotals, setFinTotals] = useState(null);
  const [finFrom, setFinFrom] = useState('');
  const [finTo, setFinTo] = useState('');
  const [isLoadingFinTx, setIsLoadingFinTx] = useState(false);
  const [finError, setFinError] = useState('');

  const supportActiveThreadIdRef = useRef(null);
  const supportInputRef = useRef(null);
  const supportMessagesListRef = useRef(null);
  const supportShouldStickToBottomRef = useRef(true);


const [supportAttachedImageUrl, setSupportAttachedImageUrl] = useState('');
const [supportUploadingImage, setSupportUploadingImage] = useState(false);
const supportFileInputRef = useRef(null);











function onPickSupportFile() {
  supportFileInputRef.current?.click();
}

async function uploadSupportImage(file) {
  if (!file) return;

  try {
    setSupportUploadingImage(true);

    const fd = new FormData();
    fd.append('image', file);

    // ✅ грузим через /api/support/upload (он общий)
    const resp = await api.post('/support/upload', fd, {
      // ВАЖНО: НЕ ставь Content-Type вручную
    });

    if (!resp.data?.ok || !resp.data?.url) {
      alert(resp.data?.error || 'Не удалось загрузить картинку');
      return;
    }

    setSupportAttachedImageUrl(String(resp.data.url));
  } catch (e) {
    console.error('[admin] uploadSupportImage error', e);
    alert('Не удалось загрузить картинку');
  } finally {
    setSupportUploadingImage(false);
  }
}

function onSupportFileChange(e) {
  const file = e.target.files?.[0];
  e.target.value = '';
  if (!file) return;
  uploadSupportImage(file);
}




    // ---------- Поддержка: загрузить список тредов ----------
  async function fetchSupportThreads() {
    try {
      setSupportLoadingThreads(true);
      setSupportThreadsError('');

      const resp = await api.get('/admin/support/threads');
      const items = Array.isArray(resp.data?.items)
        ? resp.data.items
        : Array.isArray(resp.data)
          ? resp.data
          : [];

      setSupportThreads(items);

      const unreadMap = {};
      items.forEach((thread) => {
        unreadMap[thread.id] = Number(thread.unread_for_admin || 0);
      });
      setSupportUnreadById(unreadMap);

      // Если открыт диалог, обновим его метаданные без закрытия окна.
      setSupportActiveThread((current) => {
        if (!current?.id) return current;
        return items.find((thread) => thread.id === current.id) || current;
      });
    } catch (err) {
      console.error('Error fetching support threads:', err);
      setSupportThreadsError('Не удалось загрузить список обращений');
    } finally {
      setSupportLoadingThreads(false);
    }
  }

  async function markSupportThreadRead(threadId) {
    if (!threadId) return;

    try {
      await api.post(`/admin/support/threads/${threadId}/read`);
      setSupportUnreadById((prev) => ({
        ...prev,
        [threadId]: 0,
      }));

      setSupportThreads((prev) =>
        prev.map((thread) =>
          thread.id === threadId
            ? { ...thread, unread_for_admin: 0 }
            : thread
        )
      );
    } catch (err) {
      console.error('Error marking support thread as read:', err);
    }
  }

  async function searchSupportUsers() {
    const q = supportSearchText.trim();

    if (!q) {
      setSupportSearchResults([]);
      setSupportSearchError('');
      return;
    }

    try {
      setSupportSearchLoading(true);
      setSupportSearchError('');

      const resp = await api.get('/admin/support/users/search', {
        params: { q },
      });

      const foundUsers = Array.isArray(resp.data?.items)
        ? resp.data.items
        : [];

      setSupportSearchResults(foundUsers);

      if (foundUsers.length === 0) {
        setSupportSearchError('Игрок с таким именем не найден');
      }
    } catch (err) {
      console.error('Error searching support users:', err);
      setSupportSearchResults([]);
      setSupportSearchError(
        err?.response?.data?.error || 'Не удалось найти игрока'
      );
    } finally {
      setSupportSearchLoading(false);
    }
  }

  async function startSupportThreadWithUser(user) {
    if (!user?.id) return;

    try {
      setSupportSearchError('');

      const resp = await api.post('/admin/support/thread-for-user', {
        userId: user.id,
      });

      const thread = resp.data?.thread;
      if (!thread?.id) {
        throw new Error('Сервер не вернул диалог');
      }

      setSupportSearchText('');
      setSupportSearchResults([]);

      // Сразу добавляем/поднимаем найденный диалог в локальном списке.
      setSupportThreads((prev) => {
        const rest = prev.filter((item) => item.id !== thread.id);
        return [thread, ...rest];
      });

      await openSupportThread(thread);
    } catch (err) {
      console.error('Error starting support thread:', err);
      setSupportSearchError(
        err?.response?.data?.error || 'Не удалось открыть диалог'
      );
    }
  }


// 🔁 Подгрузить сообщения активного треда (без сброса input)
async function reloadSupportMessages(threadId, opts = {}) {
  if (!threadId) return;

  const silent = !!opts.silent;

  try {
    if (!silent) setSupportLoadingMessages(true);

    const resp = await api.get(`/admin/support/threads/${threadId}/messages`);
    const msgs = Array.isArray(resp.data?.messages)
      ? resp.data.messages
      : [];

    setSupportMessages(msgs);

    if (resp.data?.thread?.id) {
      setSupportActiveThread((current) =>
        current?.id === threadId
          ? { ...current, ...resp.data.thread }
          : current
      );
    }

    setSupportUnreadById((prev) => ({
      ...prev,
      [threadId]: 0,
    }));
  } catch (err) {
    console.error('Error reloading support messages:', err);
  } finally {
    if (!silent) setSupportLoadingMessages(false);
  }
}



    // ---------- Поддержка: открыть тред и загрузить его сообщения ----------
  // ---------- Поддержка: открыть тред и загрузить его сообщения ----------
async function openSupportThread(thread) {
  if (!thread?.id) return;

  supportShouldStickToBottomRef.current = true;
  setSupportActiveThread(thread);
  setSupportUnreadById((prev) => ({ ...prev, [thread.id]: 0 }));
  setSupportMessages([]);
  setSupportNewText('');

  await reloadSupportMessages(thread.id);
  await markSupportThreadRead(thread.id);
}






    // ---------- Поддержка: отправить ответ админа ----------
async function sendSupportReply() {
  const rawText = supportNewText.trim();
  const imageUrl = supportAttachedImageUrl.trim();

  if (!rawText && !imageUrl) return;
  if (!supportActiveThread) return;

  // ✅ упаковали картинку внутрь text
  const textToSend = [
    rawText,
    imageUrl ? `[img] ${imageUrl}` : '',
  ].filter(Boolean).join('\n');

  try {
    setSupportSending(true);

    // ✅ отправляем ТОЛЬКО text
    const resp = await api.post(
      `/admin/support/threads/${supportActiveThread.id}/messages`,
      { text: textToSend }
    );

    const createdMsg = resp.data?.message;

    console.log('SENT textToSend:', textToSend);
    console.log('CREATED message from server:', createdMsg);

    if (createdMsg) {
      supportShouldStickToBottomRef.current = true;
      setSupportMessages((prev) => {
        if (prev.some((m) => m.id === createdMsg.id)) return prev;
        return [...prev, createdMsg];
      });

      const nowIso =
        createdMsg.created_at ||
        createdMsg.createdAt ||
        new Date().toISOString();

      setSupportThreads((prev) => {
        const current = prev.find((t) => t.id === supportActiveThread.id);
        if (!current) return prev;

        const nextCurrent = {
          ...current,
          lastMessageText: rawText || '📷 Картинка',
          lastMessageAt: nowIso,
          last_message_at: nowIso,
        };

        return [
          nextCurrent,
          ...prev.filter((t) => t.id !== supportActiveThread.id),
        ];
      });
    } else {
      // на всякий случай перечитаем
      await reloadSupportMessages(supportActiveThread.id, { silent: true });
    }

    setSupportNewText('');
    setSupportAttachedImageUrl('');
  } catch (err) {
    console.error('Error sending support reply:', err);
    console.error('STATUS:', err?.response?.status);
    console.error('DATA:', err?.response?.data);
    alert(err?.response?.data?.error || 'Не удалось отправить ответ');
  } finally {
    setSupportSending(false);
  }
}







    async function closeSupportThread() {
    if (!supportActiveThread) return;
    if (!window.confirm('Закрыть диалог?')) return;

    try {
     await api.patch(
  `/admin/support/threads/${supportActiveThread.id}/status`,
  { status: 'closed' }
);

      // перечитаем список тредов и сбросим активный
      setSupportActiveThread(null);
      setSupportMessages([]);
      await fetchSupportThreads();
    } catch (err) {
      console.error('Error closing support thread:', err);
      alert('Не удалось закрыть диалог');
    }
  }



async function fetchBotSettings() {
  try {
    setBotSettingsLoading(true);
    setBotSettingsError('');

    const resp = await api.get('/admin/bot-settings');
    const payload = resp.data || {};

    setBotSettingsPayload(payload);
    setBotConfig(payload.config || null);
  } catch (err) {
    console.error('Error fetching bot settings:', err);
    setBotSettingsError(
      err?.response?.data?.error ||
      'Не удалось загрузить настройки ботов'
    );
  } finally {
    setBotSettingsLoading(false);
  }
}

async function saveBotSettings() {
  if (!botConfig) return;

  try {
    setBotSettingsSaving(true);
    setBotSettingsError('');

    const resp = await api.put('/admin/bot-settings', {
      config: botConfig,
    });

    const payload = resp.data || {};
    setBotSettingsPayload(payload);
    setBotConfig(payload.config || botConfig);
    alert('Настройки ботов сохранены');
  } catch (err) {
    console.error('Error saving bot settings:', err);
    const message =
      err?.response?.data?.error ||
      'Не удалось сохранить настройки ботов';
    setBotSettingsError(message);
    alert(message);
  } finally {
    setBotSettingsSaving(false);
  }
}

function mutateBotConfig(mutator) {
  setBotConfig((previous) => {
    if (!previous) return previous;
    const next = JSON.parse(JSON.stringify(previous));
    mutator(next);
    return next;
  });
}

function BotControlTab() {
  if (botSettingsLoading && !botConfig) {
    return (
      <div className="admin-section">
        <h2>Боты — SHORT + LONG</h2>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!botConfig) {
    return (
      <div className="admin-section">
        <h2>Боты — SHORT + LONG</h2>
        {botSettingsError && (
          <div className="admin-bot-error">{botSettingsError}</div>
        )}
        <button className="admin-btn primary" onClick={fetchBotSettings}>
          Загрузить настройки
        </button>
      </div>
    );
  }

  const runtime = botSettingsPayload?.runtime || {};
  const longRuntime = botSettingsPayload?.longRuntime || {};
  const effective = botSettingsPayload?.effective || botConfig;
  const activeSchedule = botSettingsPayload?.scheduleRow || null;

  const ensurePath = (root, path) => {
    let target = root;

    for (let i = 0; i < path.length - 1; i += 1) {
      const key = path[i];

      if (
        !target[key] ||
        typeof target[key] !== 'object' ||
        Array.isArray(target[key])
      ) {
        target[key] = {};
      }

      target = target[key];
    }

    return target;
  };

  const setNumber = (path, rawValue) => {
    const value = Number(rawValue);

    mutateBotConfig((next) => {
      const target = ensurePath(next, path);
      target[path[path.length - 1]] =
        Number.isFinite(value)
          ? value
          : 0;
    });
  };

  const setBool = (path, value) => {
    mutateBotConfig((next) => {
      const target = ensurePath(next, path);
      target[path[path.length - 1]] = !!value;
    });
  };

  const NumberInput = ({
    label,
    path,
    value,
    min = 0,
    max = 1000,
  }) => (
    <label className="admin-bot-field">
      <span>{label}</span>
      <input
        type="number"
        min={min}
        max={max}
        value={value ?? 0}
        onChange={(e) =>
          setNumber(
            path,
            e.target.value
          )
        }
      />
    </label>
  );

  const Toggle = ({
    label,
    path,
    checked,
  }) => (
    <label className="admin-bot-toggle">
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) =>
          setBool(
            path,
            e.target.checked
          )
        }
      />
      <span>{label}</span>
    </label>
  );

  const addScheduleRow = () => {
    mutateBotConfig((next) => {
      if (!next.schedule || typeof next.schedule !== 'object') {
        next.schedule = {
          enabled: false,
          rows: [],
        };
      }

      next.schedule.rows =
        Array.isArray(next.schedule.rows)
          ? next.schedule.rows
          : [];

      next.schedule.rows.push({
        id: `row-${Date.now()}`,
        enabled: true,
        start: '00:00',
        end: '06:00',
        cash_bot_vs_bot_min: 0,
        cash_bot_vs_bot_max: 2,
        cash_waiting_min: 0,
        cash_waiting_max: 1,
        tournament_knockout_min: 0,
        tournament_knockout_max: 1,
        tournament_rebuy_min: 0,
        tournament_rebuy_max: 1,
      });
    });
  };

  const patchScheduleRow = (
    index,
    key,
    value
  ) => {
    mutateBotConfig((next) => {
      if (
        !Array.isArray(next.schedule?.rows) ||
        !next.schedule.rows[index]
      ) {
        return;
      }

      next.schedule.rows[index][key] = value;
    });
  };

  const removeScheduleRow = (index) => {
    mutateBotConfig((next) => {
      if (!Array.isArray(next.schedule?.rows)) {
        return;
      }

      next.schedule.rows.splice(index, 1);
    });
  };

  return (
    <div className="admin-section admin-bot-control">
      <div className="admin-bot-head">
        <div>
          <h2>Боты — SHORT + LONG</h2>

          <div className="admin-bot-muted">
            Отдельные настройки для коротких и длинных нард:
            Cash, BOT vs BOT, ожидание игроков и большие турниры Knockout / Rebuy.
          </div>
        </div>

        <div className="admin-bot-actions">
          <button
            className="admin-btn"
            onClick={fetchBotSettings}
            disabled={botSettingsLoading}
          >
            Обновить
          </button>

          <button
            className="admin-btn primary"
            onClick={saveBotSettings}
            disabled={botSettingsSaving}
          >
            {botSettingsSaving
              ? 'Сохраняю...'
              : 'Сохранить'}
          </button>
        </div>
      </div>

      {botSettingsError && (
        <div className="admin-bot-error">
          {botSettingsError}
        </div>
      )}

      <h3 className="admin-bot-section-title">
        SHORT — состояние
      </h3>

      <div className="admin-bot-runtime-grid">
        <div>
          <b>{runtime.botsTotal ?? 0}</b>
          <span>SHORT ботов всего</span>
        </div>

        <div>
          <b>{runtime.botVsBotActiveTables ?? 0}</b>
          <span>SHORT BOT vs BOT</span>
        </div>

        <div>
          <b>{runtime.waitingVisible ?? 0}</b>
          <span>SHORT ждут игрока</span>
        </div>

        <div>
          <b>{runtime.cashHumanBusy ?? 0}</b>
          <span>SHORT играют с людьми</span>
        </div>

        <div>
          <b>{runtime.tournamentBusyBots ?? 0}</b>
          <span>SHORT в турнирах</span>
        </div>

        <div>
          <b>
            {botSettingsPayload?.serverLocalTime || '—'}
          </b>
          <span>время сервера</span>
        </div>
      </div>

      <h3 className="admin-bot-section-title">
        LONG — состояние
      </h3>

      <div className="admin-bot-runtime-grid">
        <div>
          <b>{longRuntime.botsTotal ?? 0}</b>
          <span>LONG ботов всего</span>
        </div>

        <div>
          <b>{longRuntime.botVsBotActiveTables ?? 0}</b>
          <span>LONG BOT vs BOT</span>
        </div>

        <div>
          <b>{longRuntime.waitingVisible ?? 0}</b>
          <span>LONG ждут игрока</span>
        </div>

        <div>
          <b>{longRuntime.cashHumanBusy ?? 0}</b>
          <span>LONG играют с людьми</span>
        </div>

        <div>
          <b>{longRuntime.tournamentBusyBots ?? 0}</b>
          <span>LONG в турнирах</span>
        </div>

        <div>
          <b>155501</b>
          <span>LONG move model</span>
        </div>
      </div>

      {activeSchedule && (
        <div className="admin-bot-active-schedule">
          Сейчас действует SHORT-расписание:{' '}
          <b>
            {activeSchedule.start}–{activeSchedule.end}
          </b>
        </div>
      )}

      <div className="admin-bot-card">
        <h3>SHORT — общее</h3>

        <Toggle
          label="Короткие боты включены"
          path={['enabled']}
          checked={botConfig.enabled}
        />
      </div>

      <div className="admin-bot-card">
        <h3>SHORT Cash — BOT vs BOT</h3>

        <Toggle
          label="Разрешить BOT vs BOT"
          path={[
            'cash',
            'bot_vs_bot',
            'enabled',
          ]}
          checked={
            botConfig.cash?.bot_vs_bot?.enabled
          }
        />

        <div className="admin-bot-fields-grid">
          <NumberInput
            label="Столов от"
            path={[
              'cash',
              'bot_vs_bot',
              'min',
            ]}
            value={
              botConfig.cash?.bot_vs_bot?.min
            }
          />

          <NumberInput
            label="Столов до"
            path={[
              'cash',
              'bot_vs_bot',
              'max',
            ]}
            value={
              botConfig.cash?.bot_vs_bot?.max
            }
          />
        </div>

        <div className="admin-bot-effective">
          Сейчас эффективно:{' '}
          {effective.cash?.bot_vs_bot?.min ?? 0}
          –
          {effective.cash?.bot_vs_bot?.max ?? 0}
        </div>
      </div>

      <div className="admin-bot-card">
        <h3>SHORT Cash — боты ждут игрока</h3>

        <Toggle
          label="Показывать ожидающие bot-столы"
          path={[
            'cash',
            'waiting',
            'enabled',
          ]}
          checked={
            botConfig.cash?.waiting?.enabled
          }
        />

        <div className="admin-bot-fields-grid">
          <NumberInput
            label="Столов от"
            path={[
              'cash',
              'waiting',
              'min',
            ]}
            value={
              botConfig.cash?.waiting?.min
            }
          />

          <NumberInput
            label="Столов до"
            path={[
              'cash',
              'waiting',
              'max',
            ]}
            value={
              botConfig.cash?.waiting?.max
            }
          />
        </div>

        <div className="admin-bot-effective">
          Сейчас эффективно:{' '}
          {effective.cash?.waiting?.min ?? 0}
          –
          {effective.cash?.waiting?.max ?? 0}
        </div>
      </div>

      <div className="admin-bot-card">
        <h3>SHORT — ротация</h3>

        <Toggle
          label="Менять состав ожидающих ботов"
          path={[
            'cash',
            'rotation',
            'enabled',
          ]}
          checked={
            botConfig.cash?.rotation?.enabled
          }
        />

        <div className="admin-bot-fields-grid admin-bot-fields-grid--3">
          <NumberInput
            label="Ждёт минимум, мин"
            path={[
              'cash',
              'rotation',
              'waiting_min_minutes',
            ]}
            value={
              botConfig.cash?.rotation
                ?.waiting_min_minutes
            }
            min={1}
            max={1440}
          />

          <NumberInput
            label="Ждёт максимум, мин"
            path={[
              'cash',
              'rotation',
              'waiting_max_minutes',
            ]}
            value={
              botConfig.cash?.rotation
                ?.waiting_max_minutes
            }
            min={1}
            max={1440}
          />

          <NumberInput
            label="Повтор пары не раньше, мин"
            path={[
              'cash',
              'rotation',
              'pair_repeat_cooldown_minutes',
            ]}
            value={
              botConfig.cash?.rotation
                ?.pair_repeat_cooldown_minutes
            }
            max={1440}
          />

          <NumberInput
            label="Отдых минимум, мин"
            path={[
              'cash',
              'rotation',
              'cooldown_min_minutes',
            ]}
            value={
              botConfig.cash?.rotation
                ?.cooldown_min_minutes
            }
            max={1440}
          />

          <NumberInput
            label="Отдых максимум, мин"
            path={[
              'cash',
              'rotation',
              'cooldown_max_minutes',
            ]}
            value={
              botConfig.cash?.rotation
                ?.cooldown_max_minutes
            }
            max={1440}
          />
        </div>
      </div>

      <div className="admin-bot-card">
        <h3>Большие SHORT турниры</h3>

        <Toggle
          label="Турнирные боты включены"
          path={[
            'tournaments',
            'enabled',
          ]}
          checked={
            botConfig.tournaments?.enabled
          }
        />

        <div className="admin-bot-subcard">
          <h4>Knockout</h4>

          <Toggle
            label="Регистрировать ботов в Knockout"
            path={[
              'tournaments',
              'knockout',
              'enabled',
            ]}
            checked={
              botConfig.tournaments
                ?.knockout?.enabled
            }
          />

          <div className="admin-bot-fields-grid">
            <NumberInput
              label="Ботов на турнир от"
              path={[
                'tournaments',
                'knockout',
                'min',
              ]}
              value={
                botConfig.tournaments
                  ?.knockout?.min
              }
            />

            <NumberInput
              label="Ботов на турнир до"
              path={[
                'tournaments',
                'knockout',
                'max',
              ]}
              value={
                botConfig.tournaments
                  ?.knockout?.max
              }
            />
          </div>
        </div>

        <div className="admin-bot-subcard">
          <h4>Rebuy</h4>

          <Toggle
            label="Регистрировать ботов в Rebuy"
            path={[
              'tournaments',
              'rebuy',
              'enabled',
            ]}
            checked={
              botConfig.tournaments
                ?.rebuy?.enabled
            }
          />

          <Toggle
            label="Автоматический Rebuy у ботов"
            path={[
              'tournaments',
              'rebuy',
              'auto_rebuy',
            ]}
            checked={
              botConfig.tournaments
                ?.rebuy?.auto_rebuy
            }
          />

          <div className="admin-bot-fields-grid admin-bot-fields-grid--3">
            <NumberInput
              label="Ботов на турнир от"
              path={[
                'tournaments',
                'rebuy',
                'min',
              ]}
              value={
                botConfig.tournaments
                  ?.rebuy?.min
              }
            />

            <NumberInput
              label="Ботов на турнир до"
              path={[
                'tournaments',
                'rebuy',
                'max',
              ]}
              value={
                botConfig.tournaments
                  ?.rebuy?.max
              }
            />

            <NumberInput
              label="Вероятность Rebuy, %"
              path={[
                'tournaments',
                'rebuy',
                'rebuy_chance_percent',
              ]}
              value={
                botConfig.tournaments
                  ?.rebuy
                  ?.rebuy_chance_percent
              }
              max={100}
            />

            <NumberInput
              label="Макс. Rebuy одного бота"
              path={[
                'tournaments',
                'rebuy',
                'max_rebuys',
              ]}
              value={
                botConfig.tournaments
                  ?.rebuy?.max_rebuys
              }
              max={100}
            />
          </div>
        </div>

        <div className="admin-bot-fields-grid">
          <NumberInput
            label="Пауза регистрации от, сек"
            path={[
              'tournaments',
              'registration_delay_min_seconds',
            ]}
            value={
              botConfig.tournaments
                ?.registration_delay_min_seconds
            }
            min={1}
            max={3600}
          />

          <NumberInput
            label="Пауза регистрации до, сек"
            path={[
              'tournaments',
              'registration_delay_max_seconds',
            ]}
            value={
              botConfig.tournaments
                ?.registration_delay_max_seconds
            }
            min={1}
            max={3600}
          />
        </div>

        <div className="admin-bot-note">
          Системные SHORT-боты занимают место в турнире без списания своего баланса
          и без искусственного увеличения призового фонда.
        </div>
      </div>

      <div className="admin-bot-divider">
        <span>ДЛИННЫЕ НАРДЫ</span>
      </div>

      <div className="admin-bot-card admin-bot-card--long">
        <h3>LONG — общее</h3>

        <Toggle
          label="Длинные боты включены"
          path={[
            'long',
            'enabled',
          ]}
          checked={
            botConfig.long?.enabled
          }
        />

        <div className="admin-bot-note">
          Выключение LONG останавливает создание новых waiting/BOT vs BOT
          и новые регистрации в BIG LONG. Уже начатые партии не обрываются.
        </div>
      </div>

      <div className="admin-bot-card admin-bot-card--long">
        <h3>LONG Cash — BOT vs BOT</h3>

        <Toggle
          label="Разрешить LONG BOT vs BOT"
          path={[
            'long',
            'cash',
            'bot_vs_bot',
            'enabled',
          ]}
          checked={
            botConfig.long?.cash
              ?.bot_vs_bot?.enabled
          }
        />

        <div className="admin-bot-fields-grid">
          <NumberInput
            label="Столов от"
            path={[
              'long',
              'cash',
              'bot_vs_bot',
              'min',
            ]}
            value={
              botConfig.long?.cash
                ?.bot_vs_bot?.min
            }
            max={20}
          />

          <NumberInput
            label="Столов до"
            path={[
              'long',
              'cash',
              'bot_vs_bot',
              'max',
            ]}
            value={
              botConfig.long?.cash
                ?.bot_vs_bot?.max
            }
            max={20}
          />
        </div>

        <div className="admin-bot-effective">
          Сейчас эффективно:{' '}
          {effective.long?.cash
            ?.bot_vs_bot?.min ?? 0}
          –
          {effective.long?.cash
            ?.bot_vs_bot?.max ?? 0}
        </div>
      </div>

      <div className="admin-bot-card admin-bot-card--long">
        <h3>LONG Cash — боты ждут игрока</h3>

        <Toggle
          label="Показывать LONG waiting-столы"
          path={[
            'long',
            'cash',
            'waiting',
            'enabled',
          ]}
          checked={
            botConfig.long?.cash
              ?.waiting?.enabled
          }
        />

        <div className="admin-bot-fields-grid">
          <NumberInput
            label="Столов от"
            path={[
              'long',
              'cash',
              'waiting',
              'min',
            ]}
            value={
              botConfig.long?.cash
                ?.waiting?.min
            }
            max={5}
          />

          <NumberInput
            label="Столов до"
            path={[
              'long',
              'cash',
              'waiting',
              'max',
            ]}
            value={
              botConfig.long?.cash
                ?.waiting?.max
            }
            max={5}
          />
        </div>

        <div className="admin-bot-effective">
          Сейчас эффективно:{' '}
          {effective.long?.cash
            ?.waiting?.min ?? 0}
          –
          {effective.long?.cash
            ?.waiting?.max ?? 0}
        </div>

        <div className="admin-bot-note">
          Сейчас LONG-ботов пять. Бот выставляет cash waiting-стол только при достаточном
          реальном балансе под max_bet.
        </div>
      </div>

      <div className="admin-bot-card admin-bot-card--long">
        <h3>Большие LONG турниры</h3>

        <Toggle
          label="LONG турнирные боты включены"
          path={[
            'long',
            'tournaments',
            'enabled',
          ]}
          checked={
            botConfig.long
              ?.tournaments?.enabled
          }
        />

        <div className="admin-bot-subcard">
          <h4>Knockout</h4>

          <Toggle
            label="Регистрировать LONG-ботов в Knockout"
            path={[
              'long',
              'tournaments',
              'knockout',
              'enabled',
            ]}
            checked={
              botConfig.long
                ?.tournaments
                ?.knockout?.enabled
            }
          />

          <div className="admin-bot-fields-grid">
            <NumberInput
              label="Ботов на турнир от"
              path={[
                'long',
                'tournaments',
                'knockout',
                'min',
              ]}
              value={
                botConfig.long
                  ?.tournaments
                  ?.knockout?.min
              }
              max={5}
            />

            <NumberInput
              label="Ботов на турнир до"
              path={[
                'long',
                'tournaments',
                'knockout',
                'max',
              ]}
              value={
                botConfig.long
                  ?.tournaments
                  ?.knockout?.max
              }
              max={5}
            />
          </div>
        </div>

        <div className="admin-bot-subcard">
          <h4>Rebuy</h4>

          <Toggle
            label="Регистрировать LONG-ботов в Rebuy"
            path={[
              'long',
              'tournaments',
              'rebuy',
              'enabled',
            ]}
            checked={
              botConfig.long
                ?.tournaments
                ?.rebuy?.enabled
            }
          />

          <Toggle
            label="Автоматический Rebuy LONG-ботов"
            path={[
              'long',
              'tournaments',
              'rebuy',
              'auto_rebuy',
            ]}
            checked={
              botConfig.long
                ?.tournaments
                ?.rebuy?.auto_rebuy
            }
          />

          <div className="admin-bot-fields-grid admin-bot-fields-grid--3">
            <NumberInput
              label="Ботов на турнир от"
              path={[
                'long',
                'tournaments',
                'rebuy',
                'min',
              ]}
              value={
                botConfig.long
                  ?.tournaments
                  ?.rebuy?.min
              }
              max={5}
            />

            <NumberInput
              label="Ботов на турнир до"
              path={[
                'long',
                'tournaments',
                'rebuy',
                'max',
              ]}
              value={
                botConfig.long
                  ?.tournaments
                  ?.rebuy?.max
              }
              max={5}
            />

            <NumberInput
              label="Вероятность Rebuy, %"
              path={[
                'long',
                'tournaments',
                'rebuy',
                'rebuy_chance_percent',
              ]}
              value={
                botConfig.long
                  ?.tournaments
                  ?.rebuy
                  ?.rebuy_chance_percent
              }
              max={100}
            />

            <NumberInput
              label="Макс. Rebuy одного бота"
              path={[
                'long',
                'tournaments',
                'rebuy',
                'max_rebuys',
              ]}
              value={
                botConfig.long
                  ?.tournaments
                  ?.rebuy?.max_rebuys
              }
              max={100}
            />
          </div>
        </div>

        <div className="admin-bot-fields-grid">
          <NumberInput
            label="Пауза регистрации от, сек"
            path={[
              'long',
              'tournaments',
              'registration_delay_min_seconds',
            ]}
            value={
              botConfig.long
                ?.tournaments
                ?.registration_delay_min_seconds
            }
            min={1}
            max={3600}
          />

          <NumberInput
            label="Пауза регистрации до, сек"
            path={[
              'long',
              'tournaments',
              'registration_delay_max_seconds',
            ]}
            value={
              botConfig.long
                ?.tournaments
                ?.registration_delay_max_seconds
            }
            min={1}
            max={3600}
          />
        </div>

        <div className="admin-bot-note">
          LONG-боты используют настоящий User.balance.
          Регистрация возможна только при balance ≥ buy-in.
          Rebuy — только при balance ≥ стоимости rebuy.
          Автопополнения нет.
        </div>
      </div>

      <div className="admin-bot-card">
        <h3>Расписание SHORT по времени сервера</h3>

        <Toggle
          label="Использовать расписание"
          path={[
            'schedule',
            'enabled',
          ]}
          checked={
            botConfig.schedule?.enabled
          }
        />

        <div className="admin-bot-note">
          Этот блок расписания пока относится только к SHORT.
          LONG управляется отдельными настройками выше.
          При снижении диапазона уже начатые партии не обрываются.
        </div>

        <div className="admin-bot-schedule-wrap">
          <table className="admin-table admin-bot-schedule-table">
            <thead>
              <tr>
                <th>Вкл</th>
                <th>С</th>
                <th>До</th>
                <th>BvB от</th>
                <th>BvB до</th>
                <th>Ждут от</th>
                <th>Ждут до</th>
                <th>KO от</th>
                <th>KO до</th>
                <th>Rebuy от</th>
                <th>Rebuy до</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {(botConfig.schedule?.rows || []).map(
                (row, index) => (
                  <tr key={row.id || index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={row.enabled !== false}
                        onChange={(e) =>
                          patchScheduleRow(
                            index,
                            'enabled',
                            e.target.checked
                          )
                        }
                      />
                    </td>

                    <td>
                      <input
                        type="time"
                        value={row.start || '00:00'}
                        onChange={(e) =>
                          patchScheduleRow(
                            index,
                            'start',
                            e.target.value
                          )
                        }
                      />
                    </td>

                    <td>
                      <input
                        type="time"
                        value={row.end || '23:59'}
                        onChange={(e) =>
                          patchScheduleRow(
                            index,
                            'end',
                            e.target.value
                          )
                        }
                      />
                    </td>

                    {[
                      'cash_bot_vs_bot_min',
                      'cash_bot_vs_bot_max',
                      'cash_waiting_min',
                      'cash_waiting_max',
                      'tournament_knockout_min',
                      'tournament_knockout_max',
                      'tournament_rebuy_min',
                      'tournament_rebuy_max',
                    ].map((key) => (
                      <td key={key}>
                        <input
                          type="number"
                          min="0"
                          value={row[key] ?? 0}
                          onChange={(e) =>
                            patchScheduleRow(
                              index,
                              key,
                              Number(
                                e.target.value || 0
                              )
                            )
                          }
                        />
                      </td>
                    ))}

                    <td>
                      <button
                        className="admin-btn danger"
                        onClick={() =>
                          removeScheduleRow(index)
                        }
                      >
                        ×
                      </button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        <button
          className="admin-btn"
          onClick={addScheduleRow}
        >
          + Добавить интервал
        </button>
      </div>

      <div className="admin-bot-footer-actions">
        <button
          className="admin-btn primary"
          onClick={saveBotSettings}
          disabled={botSettingsSaving}
        >
          {botSettingsSaving
            ? 'Сохраняю...'
            : 'Сохранить настройки ботов'}
        </button>
      </div>
    </div>
  );
}

async function fetchLongTournamentsStats() {
  try {
    setIsLoadingLongTournaments(true);
    const params = {};
    if (longTournamentFrom) params.from = longTournamentFrom;
    if (longTournamentTo) params.to = longTournamentTo;

    const resp = await api.get('/admin/long-tournaments-stats', { params });
    setLongTournaments(resp.data.items || []);
    setLongTournamentTotals(resp.data.totals || null);
  } catch (err) {
    console.error('Error fetching LONG tournament stats:', err);
    alert('Не удалось загрузить данные по длинным турнирам');
  } finally {
    setIsLoadingLongTournaments(false);
  }
}

  // ---------- ПОКЕР: ЗАГРУЗКА РЕЙКА ПО ДНЯМ ----------
    // ---------- ПОКЕР: ЗАГРУЗКА РЕЙКА ПО ДНЯМ + ПО ЛИМИТАМ ----------
  async function fetchPokerRakeStats() {
    try {
      setIsLoadingPokerRake(true);
      setPokerRakeError('');

      const params = {};
      if (pokerRakeFrom) params.from = pokerRakeFrom;
      if (pokerRakeTo) params.to = pokerRakeTo;

      const resp = await api.get('/admin/poker-rake-stats', { params });

      const items = resp.data.items || [];
      const byLimits = resp.data.byLimits || [];
      const totalRake = Number(resp.data.totalRake || 0);
      const totalHands = Number(resp.data.totalHands || 0);

      // по дням
      setPokerRakeRows(items);
      setPokerRakeTotal(totalRake);

      // по лимитам
      setPokerRakeByLimits(byLimits);
      setPokerRakeTotalHands(totalHands);
    } catch (err) {
      console.error('Error fetching poker rake stats:', err);
      setPokerRakeError('Не удалось загрузить данные по рейку покера');
    } finally {
      setIsLoadingPokerRake(false);
    }
  }

  // ---------- ВВОД / ВЫВОД: загрузка ----------
  async function fetchFinanceTransactions() {
    try {
      setIsLoadingFinTx(true);
      setFinError('');

      const params = {};
      if (finFrom) params.from = finFrom; // формат YYYY-MM-DD
      if (finTo) params.to = finTo;

      const resp = await api.get('/admin/finance-transactions', { params });

      setFinTxRows(resp.data.items || []);
      setFinTotals(resp.data.totals || null);
    } catch (err) {
      console.error('Error fetching finance-transactions:', err);
      setFinError('Не удалось загрузить данные по вводам/выводам');
    } finally {
      setIsLoadingFinTx(false);
    }
  }







  useEffect(() => {
  supportActiveThreadIdRef.current = supportActiveThread?.id || null;
}, [supportActiveThread?.id]);

  // Фокус и прокрутка — только при смене диалога, а не при любом ререндере админки.
  useEffect(() => {
    if (!supportActiveThread?.id) return;

    supportShouldStickToBottomRef.current = true;

    window.requestAnimationFrame(() => {
      const input = supportInputRef.current;
      if (input) {
        input.focus();
        const len = input.value.length;
        try {
          input.setSelectionRange(len, len);
        } catch (e) {}
      }
    });
  }, [supportActiveThread?.id]);

  useEffect(() => {
    if (!supportActiveThread?.id) return;
    if (!supportShouldStickToBottomRef.current) return;

    window.requestAnimationFrame(() => {
      const el = supportMessagesListRef.current;
      if (!el) return;
      el.scrollTop = el.scrollHeight;
    });
  }, [supportActiveThread?.id, supportMessages.length]);

  function handleSupportMessagesScroll() {
    const el = supportMessagesListRef.current;
    if (!el) return;

    const distanceToBottom =
      el.scrollHeight - el.scrollTop - el.clientHeight;

    supportShouldStickToBottomRef.current = distanceToBottom < 80;
  }


  useEffect(() => {
    const savedRole = localStorage.getItem('role');
    setRole(savedRole);

    if (savedRole !== 'superadmin') {
      navigate('/');
      setIsLoading(false);
      return;
    }

    (async () => {
      await Promise.all([
        fetchUsers(),
        fetchPresence(),
      ]);
      setIsLoading(false);
    })();
  }, [navigate]);


useEffect(() => {
  if (role !== 'superadmin') return;

  const token = localStorage.getItem('token');
  const socket = io(API_ORIGIN, {
    auth: { token },
    transports: ['websocket'],
  });

  socket.on('connect', () => {
    console.log('[socket] connected', socket.id);
    socket.emit('support:admin-join');
  });

  socket.on('support:message', ({
    threadId,
    from,
    message,
    thread,
    unreadForAdmin,
  }) => {
    if (!threadId || !message) return;

    const activeId = supportActiveThreadIdRef.current;
    const isActive = Number(activeId) === Number(threadId);

    if (from === 'user') {
      // Новый входящий всегда поднимает диалог наверх.
      setSupportThreads((prev) => {
        const old = prev.find((item) => Number(item.id) === Number(threadId));
        const nextThread = {
          ...(old || {}),
          ...(thread || {}),
          id: threadId,
          lastMessageText:
            thread?.lastMessageText ||
            String(message.text || '').replace(/^\[img\].*$/m, '📷 Картинка'),
          lastMessageAt:
            thread?.lastMessageAt ||
            message.created_at ||
            message.createdAt ||
            new Date().toISOString(),
        };

        return [
          nextThread,
          ...prev.filter((item) => Number(item.id) !== Number(threadId)),
        ];
      });

      if (isActive) {
        setSupportMessages((prev) => {
          if (prev.some((m) => m.id === message.id)) return prev;
          return [...prev, message];
        });

        setSupportUnreadById((prev) => ({
          ...prev,
          [threadId]: 0,
        }));

        markSupportThreadRead(threadId);
      } else {
        const serverCount = Number(unreadForAdmin);

        setSupportUnreadById((prev) => ({
          ...prev,
          [threadId]: Number.isFinite(serverCount)
            ? serverCount
            : Number(prev[threadId] || 0) + 1,
        }));
      }
    }
  });

  // Игрок открыл чат — наши админские сообщения становятся "прочитано".
  socket.on('support:read', ({ threadId, messageIds, readAt }) => {
    if (!threadId || !Array.isArray(messageIds) || !messageIds.length) return;

    const ids = new Set(messageIds.map((id) => Number(id)));

    setSupportMessages((prev) =>
      prev.map((message) =>
        ids.has(Number(message.id))
          ? { ...message, read_at: readAt || new Date().toISOString() }
          : message
      )
    );
  });

  socket.on('support:thread-updated', ({ threadId }) => {
    // Если тред ещё неизвестен локально (например админ первым открыл его в другой вкладке),
    // через небольшую паузу перечитаем список. Пауза обходит короткий SELECT-cache сервера.
    if (!threadId) return;

    window.setTimeout(() => {
      fetchSupportThreads();
    }, 1700);
  });

  socket.on('disconnect', () => {
    console.log('[socket] disconnected');
  });

  return () => {
    try {
      socket.emit('support:admin-leave');
    } catch (e) {}
    socket.disconnect();
  };
}, [role]);



useEffect(() => {
  if (role !== 'superadmin') {
    return undefined;
  }

  const intervalId = window.setInterval(
    fetchPresence,
    15 * 1000
  );

  return () => {
    window.clearInterval(intervalId);
  };
}, [role]);


  useEffect(() => {
    if (role === 'superadmin' && activeTab === 'bots' && !botConfig && !botSettingsLoading) {
      fetchBotSettings();
    }
  }, [role, activeTab]);


  async function fetchUsers() {
    try {
      const resp = await api.get('/admin/users');
      setUsers(resp.data);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  }

  async function fetchPresence() {
    try {
      setPresenceLoading(true);
      setPresenceError('');

      const resp = await api.get(
        '/presence/admin'
      );

      const rows = Array.isArray(
        resp.data?.users
      )
        ? resp.data.users
        : [];

      const nextPresenceByUserId = {};

      rows.forEach((item) => {
        nextPresenceByUserId[
          String(item.id)
        ] = item;
      });

      setPresenceByUserId(
        nextPresenceByUserId
      );
    } catch (err) {
      console.error(
        'Error fetching user presence:',
        err
      );

      setPresenceError(
        'Не удалось загрузить статусы'
      );
    } finally {
      setPresenceLoading(false);
    }
  }

  // ---------- ГРУЗИМ ОТЧЁТЫ ПО КОРОТКИМ КЕШ-ИГРАМ ----------
  async function fetchShortGames() {
    try {
      setIsLoadingShortGames(true);
      setShortGamesError('');

      const params = {};
      // если даты выбраны — отправляем их на бэк
      if (shortFrom) params.from = shortFrom; // формат YYYY-MM-DD
      if (shortTo) params.to = shortTo;

      const resp = await api.get('/admin/short-games', { params });

      // бэк теперь отдаёт { items: [...], totals: {...} }
      setShortGames(resp.data.items || []);
      setShortTotals(resp.data.totals || null);
    } catch (err) {
      console.error('Error fetching short games:', err);
      setShortGamesError('Не удалось загрузить данные по играм');
    } finally {
      setIsLoadingShortGames(false);
    }
  }


    // ---------- ГРУЗИМ ОТЧЁТЫ ПО ДЛИННЫМ КЕШ-ИГРАМ ----------
  async function fetchLongGames() {
    try {
      setIsLoadingLongGames(true);
      setLongGamesError('');

      const params = {};
      if (longFrom) params.from = longFrom;
      if (longTo) params.to = longTo;

      const resp = await api.get('/admin/long-games', { params });

      setLongGames(resp.data.items || []);
      setLongTotals(resp.data.totals || null);
    } catch (err) {
      console.error('Error fetching long games:', err);
      setLongGamesError('Не удалось загрузить данные по длинным играм');
    } finally {
      setIsLoadingLongGames(false);
    }
  }


  async function banUser(userId) {
    try {
      await api.post('/admin/banUser', { userId });
      await Promise.all([
        fetchUsers(),
        fetchPresence(),
      ]);
    } catch (err) {
      console.error('Ban user error:', err);
    }
  }

  if (isLoading) return <div>Loading...</div>;

  // ---------- Вкладка "Колесо удачи" ----------
  function WheelOfFortuneTab() {
    const [buyIn, setBuyIn] = useState(2);
    const [totalTournaments, setTotalTournaments] = useState(20);
    const [prizeRows, setPrizeRows] = useState([
      { prize: 4, count: 10 },
      { prize: 8, count: 5 },
    ]);

    const addPrizeRow = () =>
      setPrizeRows((prev) => [...prev, { prize: 0, count: 0 }]);

    const handlePrizeRowChange = (index, field, value) =>
      setPrizeRows((prev) => {
        const copy = [...prev];
        copy[index] = { ...copy[index], [field]: Number(value) };
        return copy;
      });

    const removePrizeRow = (index) =>
      setPrizeRows((prev) => {
        const copy = [...prev];
        copy.splice(index, 1);
        return copy;
      });

    const totalPrize = prizeRows.reduce(
      (acc, row) => acc + row.prize * row.count,
      0
    );
    const totalIncome = 4 * buyIn * totalTournaments;
    const profit = totalIncome - totalPrize;

    async function handleSave() {
      try {
        const body = { buyIn, totalTournaments, prizeSetup: prizeRows };
        const resp = await api.post('/admin/wheelDistribution', body);
        console.log('wheelDistribution resp:', resp.data);
        alert('Схема успешно сохранена!');
      } catch (error) {
        console.error('Ошибка при сохранении схемы призов:', error);
        alert('Ошибка: ' + error.message);
      }
    }

    return (
      <div className="admin-section">
        <h2>Wheel of Fortune (Колесо удачи)</h2>

        <div className="admin-filters">
          <label>
            Количество турниров:{' '}
            <input
              type="number"
              value={totalTournaments}
              onChange={(e) => setTotalTournaments(Number(e.target.value))}
            />
          </label>

          <label>
            Турнирный взнос (buyIn):{' '}
            <select
              value={buyIn}
              onChange={(e) => setBuyIn(Number(e.target.value))}
            >
              {[1, 2, 3, 5, 10, 20, 30, 50].map((b) => (
                <option key={b} value={b}>
                  {b}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div style={{ marginTop: '1rem' }}>
          <h4>Настройки призовых фондов:</h4>
          {prizeRows.map((row, idx) => (
            <div key={idx} className="admin-row">
              <label>
                Приз ($):{' '}
                <input
                  type="number"
                  value={row.prize}
                  onChange={(e) =>
                    handlePrizeRowChange(idx, 'prize', e.target.value)
                  }
                />
              </label>

              <label>
                Кол-во (count):{' '}
                <input
                  type="number"
                  value={row.count}
                  onChange={(e) =>
                    handlePrizeRowChange(idx, 'count', e.target.value)
                  }
                />
              </label>

              <button onClick={() => removePrizeRow(idx)}>Удалить</button>
            </div>
          ))}
          <button onClick={addPrizeRow}>Добавить ещё приз</button>
        </div>

        <div className="admin-summary">
          <div>
            <strong>Сумма призов:</strong> {totalPrize} $
          </div>
          <div>
            <strong>Доход (взносы):</strong> {totalIncome} $
          </div>
          <div>
            <strong>Прибыль (убыток):</strong> {profit} $
          </div>
        </div>

        <button className="admin-btn primary" onClick={handleSave}>
          Сохранить
        </button>
      </div>
    );
  }






  async function fetchTournamentsStats() {
  try {
    setIsLoadingTournaments(true);
    const params = {};
    if (tournamentFrom) params.from = tournamentFrom;
    if (tournamentTo) params.to = tournamentTo;

    const resp = await api.get('/admin/tournaments-stats', { params });
    setTournaments(resp.data.items || []);
    setTournamentTotals(resp.data.totals || null);
  } catch (err) {
    console.error('Error fetching tournament stats:', err);
    alert('Не удалось загрузить данные по турнирам');
  } finally {
    setIsLoadingTournaments(false);
  }
}


  // ---------- Вкладка "Короткие кеш-игры" ----------
  function ShortGamesTab() {
    if (isLoadingShortGames) {
      return <div>Загрузка данных по коротким играм...</div>;
    }

    if (shortGamesError) {
      return <div style={{ color: 'red' }}>{shortGamesError}</div>;
    }

    if (!shortGames.length) {
      return <div>Пока нет записей по коротким кеш-играм.</div>;
    }

    return (
      <div className="admin-section">
        <h2>Короткие кеш-игры</h2>

        {/* Фильтры по датам */}
        <div className="admin-filters">
          <label>
            С:{' '}
            <input
              type="date"
              value={shortFrom}
              onChange={(e) => setShortFrom(e.target.value)}
            />
          </label>

          <label>
            По:{' '}
            <input
              type="date"
              value={shortTo}
              onChange={(e) => setShortTo(e.target.value)}
            />
          </label>

          <button className="admin-btn" onClick={fetchShortGames}>
            Применить
          </button>

          <button
            className="admin-btn"
            onClick={() => {
              setShortFrom('');
              setShortTo('');
              fetchShortGames();
            }}
          >
            Сбросить
          </button>
        </div>

        {/* Итоги за период */}
        {shortTotals && (
          <div className="admin-summary">
            <div>Всего игр: {shortTotals.gamesCount}</div>
            <div>
              Оборот (stake): {shortTotals.totalStake.toFixed(2)} $
            </div>
            <div>
              Комиссия сайта: {shortTotals.totalSiteCommission.toFixed(2)} $
            </div>
            <div>
              Партнёрам: {shortTotals.totalPartnerCommission.toFixed(2)} $
            </div>
            <div>
              <strong>
                Прибыль проекта: {shortTotals.totalProjectProfit.toFixed(2)} $
              </strong>
            </div>
          </div>
        )}

        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Игроки</th>
                <th>Матч</th> {/* до скольких очков играли */}
                <th>Победитель</th>
                <th>Ставка (stake)</th>
                <th>Комиссия сайта</th>
                <th>Партнёрам</th>
                <th>Прибыль проекта</th>
                <th>Баланс победителя</th>
                <th>Баланс проигравшего</th>
              </tr>
            </thead>
            <tbody>
              {shortGames.map((g) => (
                <tr key={g.id}>
                  <td>
                    {g.played_at
                      ? new Date(g.played_at).toLocaleString()
                      : ''}
                  </td>

                  <td>
                    {g.player1_name} vs {g.player2_name}
                  </td>

                  {/* Матч до скольких очков (1,3,5 и т.п.) */}
                  <td>{g.match_points || 1}</td>

                  <td>{g.winner_name}</td>

                  <td>{Number(g.stake_total || 0).toFixed(2)} $</td>
                  <td>{Number(g.site_commission || 0).toFixed(2)} $</td>
                  <td>
                    {Number(g.partner_commission_total || 0).toFixed(2)} $
                  </td>
                  <td>{Number(g.project_profit || 0).toFixed(2)} $</td>

                  <td>
                    {g.winner_balance_before != null &&
                      g.winner_balance_after != null && (
                        <>
                          {Number(g.winner_balance_before).toFixed(2)} →{' '}
                          {Number(g.winner_balance_after).toFixed(2)}
                        </>
                      )}
                  </td>

                  <td>
                    {g.loser_balance_before != null &&
                      g.loser_balance_after != null && (
                        <>
                          {Number(g.loser_balance_before).toFixed(2)} →{' '}
                          {Number(g.loser_balance_after).toFixed(2)}
                        </>
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }



    // ---------- Вкладка "Длинные кеш-игры" ----------
  function LongGamesTab() {
    if (isLoadingLongGames) {
      return <div>Загрузка данных по длинным играм...</div>;
    }

    if (longGamesError) {
      return <div style={{ color: 'red' }}>{longGamesError}</div>;
    }

    if (!longGames.length) {
      return <div>Пока нет записей по длинным кеш-играм.</div>;
    }

    return (
      <div className="admin-section">
        <h2>Длинные кеш-игры</h2>

        {/* Фильтры по датам */}
        <div className="admin-filters">
          <label>
            С:{' '}
            <input
              type="date"
              value={longFrom}
              onChange={(e) => setLongFrom(e.target.value)}
            />
          </label>

          <label>
            По:{' '}
            <input
              type="date"
              value={longTo}
              onChange={(e) => setLongTo(e.target.value)}
            />
          </label>

          <button className="admin-btn" onClick={fetchLongGames}>
            Применить
          </button>

          <button
            className="admin-btn"
            onClick={() => {
              setLongFrom('');
              setLongTo('');
              fetchLongGames();
            }}
          >
            Сбросить
          </button>
        </div>

        {/* Итоги за период */}
        {longTotals && (
          <div className="admin-summary">
            <div>Всего игр: {longTotals.gamesCount}</div>
            <div>
              Оборот (stake): {longTotals.totalStake.toFixed(2)} $
            </div>
            <div>
              Комиссия сайта: {longTotals.totalSiteCommission.toFixed(2)} $
            </div>
            <div>
              Партнёрам: {longTotals.totalPartnerCommission.toFixed(2)} $
            </div>
            <div>
              <strong>
                Прибыль проекта: {longTotals.totalProjectProfit.toFixed(2)} $
              </strong>
            </div>
          </div>
        )}

        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Игроки</th>
                <th>Матч</th>
                <th>Победитель</th>
                <th>Ставка (stake)</th>
                <th>Комиссия сайта</th>
                <th>Партнёрам</th>
                <th>Прибыль проекта</th>
                <th>Баланс победителя</th>
                <th>Баланс проигравшего</th>
                <th>Причина окончания</th>
              </tr>
            </thead>
            <tbody>
              {longGames.map((g) => (
                <tr key={g.id}>
                  <td>
                    {g.played_at
                      ? new Date(g.played_at).toLocaleString()
                      : ''}
                  </td>

                  <td>
                    {g.player1_name} vs {g.player2_name}
                  </td>

                  <td>{g.match_points || 1}</td>

                  <td>{g.winner_name}</td>

                  <td>{Number(g.stake_total || 0).toFixed(2)} $</td>
                  <td>{Number(g.site_commission || 0).toFixed(2)} $</td>
                  <td>
                    {Number(g.partner_commission_total || 0).toFixed(2)} $
                  </td>
                  <td>{Number(g.project_profit || 0).toFixed(2)} $</td>

                  <td>
                    {g.winner_balance_before != null &&
                      g.winner_balance_after != null && (
                        <>
                          {Number(g.winner_balance_before).toFixed(2)} →{' '}
                          {Number(g.winner_balance_after).toFixed(2)}
                        </>
                      )}
                  </td>

                  <td>
                    {g.loser_balance_before != null &&
                      g.loser_balance_after != null && (
                        <>
                          {Number(g.loser_balance_before).toFixed(2)} →{' '}
                          {Number(g.loser_balance_after).toFixed(2)}
                        </>
                      )}
                  </td>

                  <td>{g.finish_reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

function TournamentStatsTab() {
  if (isLoadingTournaments) return <div>Загрузка турниров...</div>;

  return (
    <div className="admin-section">
      <h2>Турниры Sit&Go</h2>

      <div className="admin-filters">
        <label>С:
          <input type="date" value={tournamentFrom}
                 onChange={e => setTournamentFrom(e.target.value)} />
        </label>
        <label>По:
          <input type="date" value={tournamentTo}
                 onChange={e => setTournamentTo(e.target.value)} />
        </label>
        <button className="admin-btn" onClick={fetchTournamentsStats}>Применить</button>
        <button className="admin-btn" onClick={() => {
          setTournamentFrom('');
          setTournamentTo('');
          fetchTournamentsStats();
        }}>Сбросить</button>
      </div>

      {tournamentTotals && (
        <div className="admin-summary">
          <div>Всего турниров: {tournamentTotals.tournamentsCount}</div>
          <div>Оборот: {tournamentTotals.totalIncome.toFixed(2)} $</div>
          <div>Призы: {tournamentTotals.totalPrize.toFixed(2)} $</div>
          <div><strong>Прибыль проекта: {tournamentTotals.totalProfit.toFixed(2)} $</strong></div>
        </div>
      )}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Дата</th>
              <th>Buy-in</th>
              <th>Игроков</th>
              <th>Игроки</th> 
              <th>Победитель</th>
              <th>Приз</th>
              <th>Доход</th>
              <th>Прибыль</th>
              <th>Статус</th>
            </tr>
          </thead>
         <tbody>
  {tournaments.map((t) => (
    <tr key={t.id}>
      {/* Дата завершения турнира */}
      <td>{t.updatedAt ? new Date(t.updatedAt).toLocaleString() : ''}</td>

      {/* Buy-in */}
      <td>{t.buyIn}</td>

      {/* Кол-во игроков */}
      <td>{t.playersCount}</td>

      {/* 🆕 Список игроков (массив players с бэка) */}
      <td>{(t.players || []).join(', ')}</td>

      {/* 🆕 Победитель (username) */}
      <td>{t.winner || '-'}</td>

      {/* Призовой фонд турнира */}
      <td>{t.prize}</td>

      {/* Доход = buyIn * игроков */}
      <td>{t.income}</td>

      {/* Прибыль = доход - приз */}
      <td
        style={{
          color: Number(t.profit) < 0 ? 'red' : 'lightgreen',
        }}
      >
        {Number(t.profit || 0).toFixed(2)}
      </td>

      {/* Статус (обычно finished) */}
      <td>{t.status}</td>
    </tr>
  ))}
</tbody>

        </table>
      </div>
    </div>
  );
}
const canSend = !!supportNewText.trim() || !!supportAttachedImageUrl.trim();

  function SupportTab() {
    const API_ORIGIN_LOCAL = (
      process.env.REACT_APP_API_ORIGIN ||
      process.env.REACT_APP_API_URL ||
      (typeof window !== 'undefined' ? window.location.origin : '')
    ).replace(/\/+$/, '');

    function resolveUrl(pathOrUrl) {
      if (!pathOrUrl) return '';
      const s = String(pathOrUrl);
      if (s.startsWith('http://') || s.startsWith('https://')) return s;
      return API_ORIGIN_LOCAL ? `${API_ORIGIN_LOCAL}${s}` : s;
    }

    function parseSupportText(raw) {
      const text = String(raw || '');
      const lines = text.split('\n');
      const images = [];
      const textLines = [];

      for (const line of lines) {
        const trimmed = String(line || '').trim();
        if (trimmed.startsWith('[img]')) {
          const url = trimmed.slice(5).trim();
          if (url) images.push(url);
        } else {
          textLines.push(line);
        }
      }

      return {
        textOnly: textLines.join('\n').trim(),
        images,
      };
    }

    return (
      <div className="admin-section">
        <h2>Поддержка игроков</h2>

        <div className="admin-filters" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="admin-btn" onClick={fetchSupportThreads}>
            Обновить список
          </button>

          <input
            type="text"
            value={supportSearchText}
            onChange={(e) => setSupportSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                searchSupportUsers();
              }
            }}
            placeholder="Найти игрока по нику…"
            style={{
              minWidth: 240,
              padding: '6px 8px',
              borderRadius: 4,
              border: '1px solid #555',
              background: '#111',
              color: '#fff',
            }}
          />

          <button
            className="admin-btn primary"
            type="button"
            onClick={searchSupportUsers}
            disabled={supportSearchLoading || !supportSearchText.trim()}
          >
            {supportSearchLoading ? 'Ищу…' : 'Найти'}
          </button>

          {supportLoadingThreads && (
            <span style={{ marginLeft: 4 }}>Загрузка…</span>
          )}

          {supportThreadsError && (
            <span style={{ color: 'red' }}>
              {supportThreadsError}
            </span>
          )}
        </div>

        {(supportSearchError || supportSearchResults.length > 0) && (
          <div
            style={{
              marginTop: 8,
              padding: 8,
              border: '1px solid #444',
              borderRadius: 6,
              maxWidth: 520,
            }}
          >
            {supportSearchError && (
              <div style={{ color: '#ff7777', fontSize: 13 }}>
                {supportSearchError}
              </div>
            )}

            {!supportSearchError && supportSearchResults.length === 0 && (
              <div style={{ opacity: 0.7, fontSize: 13 }}>
                Игрок не найден.
              </div>
            )}

            {supportSearchResults.map((user) => (
              <button
                key={user.id}
                type="button"
                className="admin-btn"
                onClick={() => startSupportThreadWithUser(user)}
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                  marginBottom: 6,
                  textAlign: 'left',
                }}
              >
                <strong>{user.username}</strong>
                <span style={{ opacity: 0.7 }}>ID {user.id}</span>
              </button>
            ))}
          </div>
        )}

        <div
          className="support-layout"
          style={{
            display: 'grid',
            gridTemplateColumns: '280px minmax(0, 1fr)',
            gap: '16px',
            marginTop: '1rem',
            alignItems: 'stretch',
          }}
        >
          <div
            className="support-threads"
            style={{
              border: '1px solid #444',
              borderRadius: 6,
              padding: 8,
              height: '520px',
              overflowY: 'auto',
            }}
          >
            {supportThreads.length === 0 && !supportLoadingThreads && (
              <div style={{ opacity: 0.7, fontSize: 13 }}>
                Обращений пока нет.
              </div>
            )}

            {supportThreads.map((thread) => {
              const username =
                thread.username ||
                thread.user?.username ||
                thread.User?.username ||
                `user#${thread.user_id}`;

              const lastText =
                thread.lastMessageText ||
                thread.last_text ||
                '';

              const status = thread.status || 'open';
              const unread = Number(
                supportUnreadById[thread.id] ??
                thread.unread_for_admin ??
                0
              );

              const isActive =
                Number(supportActiveThread?.id) === Number(thread.id);

              return (
                <div
                  key={thread.id}
                  onClick={() => openSupportThread(thread)}
                  style={{
                    padding: '8px 9px',
                    marginBottom: 6,
                    borderRadius: 6,
                    cursor: 'pointer',
                    background: isActive ? '#333b55' : '#222',
                    border: isActive
                      ? '1px solid #5af'
                      : '1px solid transparent',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 8,
                    }}
                  >
                    <div style={{ fontWeight: 700 }}>{username}</div>

                    {unread > 0 && (
                      <span
                        style={{
                          minWidth: 20,
                          height: 20,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: '#d9534f',
                          borderRadius: 999,
                          padding: '0 6px',
                          fontSize: 12,
                          fontWeight: 700,
                        }}
                      >
                        {unread > 99 ? '99+' : unread}
                      </span>
                    )}
                  </div>

                  <div
                    style={{
                      fontSize: 12,
                      opacity: 0.8,
                      marginTop: 3,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {lastText || 'Без сообщений'}
                  </div>

                  <div style={{ fontSize: 11, marginTop: 4, opacity: 0.75 }}>
                    Статус: <strong>{status === 'open' ? 'открыт' : status}</strong>
                  </div>
                </div>
              );
            })}
          </div>

          <div
            className="support-messages-panel"
            style={{
              border: '1px solid #444',
              borderRadius: 6,
              padding: 8,
              display: 'flex',
              flexDirection: 'column',
              height: '520px',
              minHeight: 0,
            }}
          >
            {!supportActiveThread && (
              <div style={{ opacity: 0.7 }}>
                Выберите диалог слева или найдите игрока по нику.
              </div>
            )}

            {supportActiveThread && (
              <>
                <div
                  style={{
                    marginBottom: 8,
                    paddingBottom: 6,
                    borderBottom: '1px solid #444',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 12,
                  }}
                >
                  <div>
                    <strong>
                      Диалог с{' '}
                      {supportActiveThread.username ||
                        supportActiveThread.user?.username ||
                        supportActiveThread.User?.username ||
                        `user#${supportActiveThread.user_id}`}
                    </strong>
                  </div>

                  <div style={{ fontSize: 12, opacity: 0.8 }}>
                    Статус:{' '}
                    {supportActiveThread.status === 'open'
                      ? 'открыт'
                      : supportActiveThread.status}
                  </div>
                </div>

                <div
                  className="support-messages-list"
                  ref={supportMessagesListRef}
                  onScroll={handleSupportMessagesScroll}
                  style={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    marginBottom: 8,
                    paddingRight: 4,
                    overscrollBehavior: 'contain',
                  }}
                >
                  {supportLoadingMessages && (
                    <div style={{ fontSize: 13, opacity: 0.7 }}>
                      Загрузка сообщений…
                    </div>
                  )}

                  {!supportLoadingMessages &&
                    supportMessages.map((message) => {
                      const fromAdmin = !!message.from_admin;
                      const authorName = fromAdmin
                        ? 'Админ'
                        : message.Author?.username ||
                          message.user?.username ||
                          'Игрок';

                      const created =
                        message.created_at ||
                        message.createdAt ||
                        null;

                      const { textOnly, images } = parseSupportText(message.text);
                      const isRead = !!message.read_at;

                      return (
                        <div
                          key={message.id}
                          style={{
                            marginBottom: 7,
                            display: 'flex',
                            justifyContent: fromAdmin
                              ? 'flex-end'
                              : 'flex-start',
                          }}
                        >
                          <div
                            style={{
                              maxWidth: '72%',
                              padding: '7px 9px',
                              borderRadius: 7,
                              background: fromAdmin ? '#345678' : '#333',
                              textAlign: 'left',
                            }}
                          >
                            <div
                              style={{
                                fontSize: 11,
                                opacity: 0.8,
                                marginBottom: 3,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                                flexWrap: 'wrap',
                              }}
                            >
                              <span>{authorName}</span>

                              {created && (
                                <span>· {new Date(created).toLocaleString()}</span>
                              )}

                              {fromAdmin && (
                                <span
                                  title={isRead ? 'Игрок прочитал' : 'Ещё не прочитано'}
                                  style={{
                                    color: isRead ? '#4ade80' : '#a8b0bd',
                                    fontWeight: 900,
                                    fontSize: 14,
                                  }}
                                >
                                  ✓
                                </span>
                              )}
                            </div>

                            {textOnly ? (
                              <div style={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>
                                {textOnly}
                              </div>
                            ) : null}

                            {images.map((url, idx) => {
                              const src = resolveUrl(url);
                              return (
                                <a
                                  key={`${message.id}-img-${idx}`}
                                  href={src}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{ display: 'inline-block', marginTop: 6 }}
                                >
                                  <img
                                    src={src}
                                    alt="support"
                                    style={{
                                      maxWidth: 240,
                                      maxHeight: 240,
                                      borderRadius: 8,
                                      display: 'block',
                                    }}
                                  />
                                </a>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}

                  {!supportLoadingMessages && supportMessages.length === 0 && (
                    <div style={{ opacity: 0.7, fontSize: 13 }}>
                      Сообщений пока нет. Напишите игроку первым.
                    </div>
                  )}
                </div>

                {supportAttachedImageUrl && (
                  <div
                    style={{
                      padding: '6px 8px',
                      borderTop: '1px solid #333',
                      marginBottom: 8,
                    }}
                  >
                    <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 6 }}>
                      Прикреплено:
                    </div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                      <img
                        src={resolveUrl(supportAttachedImageUrl)}
                        alt="preview"
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 8,
                          objectFit: 'cover',
                        }}
                      />
                      <button
                        type="button"
                        className="admin-btn"
                        onClick={() => setSupportAttachedImageUrl('')}
                      >
                        Убрать
                      </button>
                    </div>
                  </div>
                )}

                <div
                  className="support-input-row"
                  style={{ display: 'flex', gap: 8, alignItems: 'center' }}
                >
                  <input
                    ref={supportInputRef}
                    type="text"
                    placeholder="Ответ игроку…"
                    value={supportNewText}
                    onChange={(e) => setSupportNewText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        if (canSend && !supportSending && !supportUploadingImage) {
                          sendSupportReply();
                        }
                      }
                    }}
                    style={{
                      flex: 1,
                      padding: '6px 8px',
                      borderRadius: 4,
                      border: '1px solid #555',
                      background: '#111',
                      color: '#fff',
                    }}
                  />

                  <input
                    ref={supportFileInputRef}
                    type="file"
                    accept="image/png,image/jpeg,image/webp"
                    style={{ display: 'none' }}
                    onChange={onSupportFileChange}
                  />

                  <button
                    className="admin-btn"
                    type="button"
                    onClick={onPickSupportFile}
                    disabled={supportUploadingImage || supportSending}
                    title="Прикрепить картинку"
                  >
                    {supportUploadingImage ? '...' : '🖼️'}
                  </button>

                  <button
                    className="admin-btn primary"
                    type="button"
                    onClick={sendSupportReply}
                    disabled={supportSending || supportUploadingImage || !canSend}
                  >
                    {supportSending ? '...' : 'Отправить'}
                  </button>

                  <button
                    className="admin-btn"
                    type="button"
                    onClick={closeSupportThread}
                  >
                    Закрыть
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }





function LongTournamentStatsTab() {
  if (isLoadingLongTournaments) {
    return <div>Загрузка длинных турниров...</div>;
  }

  return (
    <div className="admin-section">
      <h2>Турниры Long (нарды)</h2>

      <div className="admin-filters">
        <label>
          С:
          <input
            type="date"
            value={longTournamentFrom}
            onChange={(e) => setLongTournamentFrom(e.target.value)}
          />
        </label>

        <label>
          По:
          <input
            type="date"
            value={longTournamentTo}
            onChange={(e) => setLongTournamentTo(e.target.value)}
          />
        </label>

        <button className="admin-btn" onClick={fetchLongTournamentsStats}>
          Применить
        </button>

        <button
          className="admin-btn"
          onClick={() => {
            setLongTournamentFrom('');
            setLongTournamentTo('');
            fetchLongTournamentsStats();
          }}
        >
          Сбросить
        </button>
      </div>

      {longTournamentTotals && (
        <div className="admin-summary">
          <div>Всего турниров: {longTournamentTotals.tournamentsCount}</div>
          <div>Оборот: {longTournamentTotals.totalIncome.toFixed(2)} $</div>
          <div>Призы: {longTournamentTotals.totalPrize.toFixed(2)} $</div>
          <div>
            <strong>
              Прибыль проекта: {longTournamentTotals.totalProfit.toFixed(2)} $
            </strong>
          </div>
        </div>
      )}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Дата</th>
              <th>Buy-in</th>
              <th>Игроков</th>
              <th>Игроки</th>
              <th>Победитель</th>
              <th>Приз</th>
              <th>Доход</th>
              <th>Прибыль</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {longTournaments.map((t) => (
              <tr key={t.id}>
                {/* дата окончания турнира */}
                <td>
                  {t.updatedAt ? new Date(t.updatedAt).toLocaleString() : ''}
                </td>

                {/* buy-in */}
                <td>{t.buyIn}</td>

                {/* количество игроков */}
                <td>{t.playersCount}</td>

                {/* список ников */}
                <td>{(t.players || []).join(', ')}</td>

                {/* победитель */}
                <td>{t.winner || '-'}</td>

                {/* какой приз выпал (из колеса) */}
                <td>{t.prize}</td>

                {/* доход = buyIn * игроков */}
                <td>{t.income}</td>

                {/* прибыль = доход - приз */}
                <td
                  style={{
                    color: Number(t.profit) < 0 ? 'red' : 'lightgreen',
                  }}
                >
                  {Number(t.profit || 0).toFixed(2)}
                </td>

                {/* статус (обычно finished) */}
                <td>{t.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

  // ---------- Вкладка "Покер: рейк по дням" ----------
   // ---------- Вкладка "Покер: рейк по дням + по столам" ----------
  function PokerRakeTab() {
    if (isLoadingPokerRake) {
      return <div>Загрузка статистики по покеру...</div>;
    }

    return (
      <div className="admin-section">
        <h2>Покер — рейк</h2>

        {/* Фильтры по датам */}
        <div className="admin-filters">
          <label>
            С:{' '}
            <input
              type="date"
              value={pokerRakeFrom}
              onChange={(e) => setPokerRakeFrom(e.target.value)}
            />
          </label>

          <label>
            По:{' '}
            <input
              type="date"
              value={pokerRakeTo}
              onChange={(e) => setPokerRakeTo(e.target.value)}
            />
          </label>

          <button className="admin-btn" onClick={fetchPokerRakeStats}>
            Применить
          </button>

          <button
            className="admin-btn"
            onClick={() => {
              setPokerRakeFrom('');
              setPokerRakeTo('');
              fetchPokerRakeStats();
            }}
          >
            Сбросить
          </button>
        </div>

        {/* Ошибка, если есть */}
        {pokerRakeError && (
          <div style={{ color: 'red', marginBottom: '1rem' }}>
            {pokerRakeError}
          </div>
        )}

        {/* Итоги за период */}
        <div className="admin-summary">
          <div>
            <strong>
              Всего рейка за период: {pokerRakeTotal.toFixed(2)} $
            </strong>
          </div>
          <div>
            <strong>Всего раздач: {pokerRakeTotalHands}</strong>
          </div>
        </div>

        {/* === 1. Таблица по дням === */}
        <h3>По дням</h3>
        {pokerRakeRows.length === 0 ? (
          <div>Пока нет данных по рейку за выбранный период.</div>
        ) : (
          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Дата</th>
                  <th>Рейк за день ($)</th>
                  <th>Раздач за день</th>
                </tr>
              </thead>
              <tbody>
                {pokerRakeRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.day}</td>
                    <td>{Number(row.rake || 0).toFixed(2)}</td>
                    <td>{row.handsCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* === 2. Таблица по лимитам / столам === */}
        <h3 style={{ marginTop: '2rem' }}>По столам / лимитам</h3>
        {pokerRakeByLimits.length === 0 ? (
          <div>Пока нет данных по лимитам за выбранный период.</div>
        ) : (
          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Стол / лимит</th>
                  <th>Рейк ($)</th>
                  <th>Раздач</th>
                </tr>
              </thead>
              <tbody>
                {pokerRakeByLimits.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.limitLabel}</td>
                    <td>{Number(row.rake || 0).toFixed(2)}</td>
                    <td>{row.handsCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  // ---------- Вкладка "Ввод / вывод" ----------
  function FinanceTransactionsTab() {
    if (isLoadingFinTx) {
      return <div>Загрузка данных по вводам/выводам...</div>;
    }

    return (
      <div className="admin-section">
        <h2>Ввод / вывод средств</h2>

        {/* Фильтры по датам */}
        <div className="admin-filters">
          <label>
            С:{' '}
            <input
              type="date"
              value={finFrom}
              onChange={(e) => setFinFrom(e.target.value)}
            />
          </label>

          <label>
            По:{' '}
            <input
              type="date"
              value={finTo}
              onChange={(e) => setFinTo(e.target.value)}
            />
          </label>

          <button className="admin-btn" onClick={fetchFinanceTransactions}>
            Применить
          </button>

          <button
            className="admin-btn"
            onClick={() => {
              setFinFrom('');
              setFinTo('');
              fetchFinanceTransactions();
            }}
          >
            Сбросить
          </button>
        </div>

        {/* Ошибка */}
        {finError && (
          <div style={{ color: 'red', marginBottom: '1rem' }}>{finError}</div>
        )}

        {/* Итоги за период */}
        {finTotals && (
          <div className="admin-summary">
            <div>
              Всего депозитов:{' '}
              <strong>{Number(finTotals.totalDeposits || 0).toFixed(2)} $</strong>
            </div>
            <div>
              Всего выводов:{' '}
              <strong>{Number(finTotals.totalWithdrawals || 0).toFixed(2)} $</strong>
            </div>
            <div>
              Чистый приток (депозиты − выводы):{' '}
              <strong>{Number(finTotals.net || 0).toFixed(2)} $</strong>
            </div>
          </div>
        )}

        {/* Таблица */}
        {finTxRows.length === 0 ? (
          <div>За выбранный период нет операций ввода/вывода.</div>
        ) : (
          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Дата</th>
                  <th>Пользователь</th>
                  <th>Тип</th>
                  <th>Сумма</th>
                  <th>Статус</th>
                  <th>Способ</th>
                  <th>Реквизиты</th>
                  <th>Описание</th>
                  <th>Комментарий админа</th>
                </tr>
              </thead>
              <tbody>
                {finTxRows.map((tx) => {
                  const isDeposit = tx.type === 'deposit';
                  const isWithdraw = tx.type === 'withdraw';

                  const typeLabel = isDeposit
                    ? 'Ввод'
                    : isWithdraw
                    ? 'Вывод'
                    : tx.type;

                  let statusLabel = tx.status || '';
                  if (statusLabel === 'pending') statusLabel = 'в ожидании';
                  if (statusLabel === 'done') statusLabel = 'выполнено';
                  if (statusLabel === 'rejected') statusLabel = 'отклонено';

                  let payoutLabel = '';
                  if (tx.payout_method === 'crypto') payoutLabel = 'Крипта';
                  else if (tx.payout_method === 'card') payoutLabel = 'Карта';
                  else if (tx.payout_method === 'system') payoutLabel = 'Система';

                  let details = '';
                  if (tx.payout_method === 'crypto') {
                    details = `${tx.wallet_address || ''} ${
                      tx.network ? `(${tx.network})` : ''
                    }`;
                  } else if (tx.payout_method === 'card') {
                    details = [
                      tx.card_number,
                      tx.bank_name,
                      tx.full_name,
                      tx.phone,
                    ]
                      .filter(Boolean)
                      .join(' | ');
                  }

                  return (
                    <tr key={tx.id}>
                      <td>
                        {tx.created_at
                          ? new Date(tx.created_at).toLocaleString()
                          : ''}
                      </td>

                      <td>{tx.username || '-'}</td>

                      <td>{typeLabel}</td>

                      <td>{Number(tx.amount || 0).toFixed(2)} $</td>

                      <td>{statusLabel || '-'}</td>

                      <td>{payoutLabel || '-'}</td>

                      <td>{details || '-'}</td>

                      <td>{tx.description || ''}</td>

                      <td>{tx.admin_comment || ''}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }



  // ============================================================
// БАННЕРЫ
// ============================================================

async function fetchSiteBanners() {
  try {
    setBannerError('');

    const resp =
      await api.get(
        '/site-banners/admin'
      );

    setSiteBanners(
      Array.isArray(resp.data?.banners)
        ? resp.data.banners
        : []
    );
  } catch (err) {
    console.error(
      '[admin] fetchSiteBanners',
      err
    );

    setBannerError(
      err.response?.data?.error ||
      'Не удалось загрузить баннеры'
    );
  }
}


// ============================================================
// ЗАГРУЗИТЬ КАРТИНКУ
// ============================================================

async function uploadBannerImage(file) {
  if (!file) return;

  try {
    setBannerUploading(true);
    setBannerError('');

    const fd = new FormData();

    fd.append(
      'image',
      file
    );

    const resp =
      await api.post(
        '/site-banners/admin/upload',
        fd
      );

    if (
      !resp.data?.ok ||
      !resp.data?.image_url
    ) {
      throw new Error(
        resp.data?.error ||
        'Ошибка загрузки'
      );
    }

    setBannerImageUrl(
      resp.data.image_url
    );
  } catch (err) {
    console.error(
      '[admin] uploadBannerImage',
      err
    );

    setBannerError(
      err.response?.data?.error ||
      err.message ||
      'Не удалось загрузить картинку'
    );
  } finally {
    setBannerUploading(false);
  }
}


// ============================================================
// ВЫБОР ФАЙЛА
// ============================================================

function onBannerFileChange(e) {
  const file =
    e.target.files?.[0];

  e.target.value = '';

  if (!file) return;

  uploadBannerImage(file);
}


// ============================================================
// СОЗДАТЬ БАННЕР
// ============================================================

async function createSiteBanner(e) {
  e.preventDefault();

  if (!bannerName.trim()) {
    alert(
      'Укажи название баннера'
    );
    return;
  }

  if (!bannerImageUrl) {
    alert(
      'Сначала загрузи картинку'
    );
    return;
  }

  try {
    setBannerSaving(true);
    setBannerError('');

    await api.post(
      '/site-banners/admin',
      {
        name:
          bannerName.trim(),

        image_url:
          bannerImageUrl,

        link_url:
          bannerLinkUrl.trim(),

        button_text:
          bannerButtonText.trim(),

        is_active:
          bannerIsActive,
      }
    );


    // очищаем форму

    setBannerName('');
    setBannerImageUrl('');
    setBannerLinkUrl('');
    setBannerButtonText('');
    setBannerIsActive(true);


    await fetchSiteBanners();

    alert(
      'Баннер создан'
    );
  } catch (err) {
    console.error(
      '[admin] createSiteBanner',
      err
    );

    setBannerError(
      err.response?.data?.error ||
      'Не удалось создать баннер'
    );
  } finally {
    setBannerSaving(false);
  }
}


// ============================================================
// ВКЛ / ВЫКЛ БАННЕР
// ============================================================

async function toggleSiteBanner(
  banner
) {
  try {
    await api.put(
      `/site-banners/admin/${banner.id}`,
      {
        is_active:
          !banner.is_active,
      }
    );


    setSiteBanners(
      (prev) =>
        prev.map((item) =>
          item.id === banner.id
            ? {
                ...item,
                is_active:
                  !banner.is_active,
              }
            : item
        )
    );
  } catch (err) {
    console.error(
      '[admin] toggleSiteBanner',
      err
    );

    alert(
      err.response?.data?.error ||
      'Не удалось изменить баннер'
    );
  }
}


// ============================================================
// УДАЛИТЬ
// ============================================================

async function deleteSiteBanner(
  banner
) {
  const ok =
    window.confirm(
      `Удалить баннер "${banner.name}"?`
    );

  if (!ok) return;


  try {
    await api.delete(
      `/site-banners/admin/${banner.id}`
    );


    setSiteBanners(
      (prev) =>
        prev.filter(
          (item) =>
            item.id !== banner.id
        )
    );
  } catch (err) {
    console.error(
      '[admin] deleteSiteBanner',
      err
    );

    alert(
      err.response?.data?.error ||
      'Не удалось удалить баннер'
    );
  }
}


// ============================================================
// ВКЛАДКА БАННЕРОВ
// ============================================================

function SiteBannersTab() {
  return (
    <div className="admin-section">

      <h2>
        Рекламные баннеры
      </h2>


      <p>
        Создай баннер, загрузи
        готовую картинку и при
        необходимости укажи ссылку.
      </p>


      {bannerError && (
        <div
          style={{
            marginBottom: 15,
            color: '#ff6b6b',
          }}
        >
          {bannerError}
        </div>
      )}


      {/* =========================
          СОЗДАНИЕ
      ========================= */}

      <form
        onSubmit={createSiteBanner}
        style={{
          maxWidth: 750,
          padding: 20,
          marginBottom: 30,
          border:
            '1px solid rgba(255,255,255,0.15)',
          borderRadius: 12,
        }}
      >

        <h3>
          Новый баннер
        </h3>


        <div
          style={{
            marginBottom: 15,
          }}
        >
          <div
            style={{
              marginBottom: 6,
            }}
          >
            Название для админки
          </div>

          <input
            type="text"
            value={bannerName}
            onChange={(e) =>
              setBannerName(
                e.target.value
              )
            }
            placeholder="Например: Реклама турниров"
            style={{
              width: '100%',
              padding: 10,
            }}
          />
        </div>


        <div
          style={{
            marginBottom: 15,
          }}
        >
          <div
            style={{
              marginBottom: 6,
            }}
          >
            Картинка баннера
          </div>

          <input
            type="file"
            accept="image/png,image/jpeg,image/webp"
            onChange={
              onBannerFileChange
            }
          />

          {bannerUploading && (
            <div
              style={{
                marginTop: 8,
              }}
            >
              Загружаю...
            </div>
          )}
        </div>


        {bannerImageUrl && (
          <div
            style={{
              marginBottom: 20,
            }}
          >

            <div
              style={{
                marginBottom: 6,
              }}
            >
              Предпросмотр:
            </div>

            <img
              src={`${API_ORIGIN}${bannerImageUrl}`}
              alt="Предпросмотр"
              style={{
                display: 'block',
                maxWidth: '100%',
                maxHeight: 400,
                borderRadius: 10,
                border:
                  '1px solid rgba(255,255,255,0.15)',
              }}
            />

          </div>
        )}


        <div
          style={{
            marginBottom: 15,
          }}
        >
          <div
            style={{
              marginBottom: 6,
            }}
          >
            Ссылка
          </div>

          <input
            type="text"
            value={bannerLinkUrl}
            onChange={(e) =>
              setBannerLinkUrl(
                e.target.value
              )
            }
            placeholder="/big-tournaments"
            style={{
              width: '100%',
              padding: 10,
            }}
          />

          <div
            style={{
              opacity: 0.7,
              fontSize: 13,
              marginTop: 5,
            }}
          >
            Можно оставить пустой.
            Например:
            {' '}
            /big-tournaments
          </div>
        </div>


        <div
          style={{
            marginBottom: 15,
          }}
        >
          <div
            style={{
              marginBottom: 6,
            }}
          >
            Текст кнопки
          </div>

          <input
            type="text"
            value={
              bannerButtonText
            }
            onChange={(e) =>
              setBannerButtonText(
                e.target.value
              )
            }
            placeholder="Перейти"
            style={{
              width: '100%',
              padding: 10,
            }}
          />

          <div
            style={{
              opacity: 0.7,
              fontSize: 13,
              marginTop: 5,
            }}
          >
            Если оставить пустым —
            отдельной кнопки под
            картинкой не будет.
          </div>
        </div>


        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 20,
            cursor: 'pointer',
          }}
        >

          <input
            type="checkbox"
            checked={
              bannerIsActive
            }
            onChange={(e) =>
              setBannerIsActive(
                e.target.checked
              )
            }
          />

          Сразу активировать баннер

        </label>


        <button
          type="submit"
          className="admin-btn"
          disabled={
            bannerSaving ||
            bannerUploading
          }
        >
          {bannerSaving
            ? 'Создаю...'
            : 'Создать баннер'}
        </button>

      </form>


      {/* =========================
          СОЗДАННЫЕ
      ========================= */}

      <h3>
        Созданные баннеры
      </h3>


      {!siteBanners.length && (
        <div>
          Баннеров пока нет.
        </div>
      )}


      <div
        style={{
          display: 'grid',
          gap: 20,
        }}
      >

        {siteBanners.map(
          (banner) => (

            <div
              key={banner.id}
              style={{
                padding: 15,
                border:
                  banner.is_active
                    ? '1px solid #5cad69'
                    : '1px solid rgba(255,255,255,0.15)',

                borderRadius: 12,

                opacity:
                  banner.is_active
                    ? 1
                    : 0.65,
              }}
            >

              <div
                style={{
                  display: 'flex',
                  justifyContent:
                    'space-between',
                  gap: 15,
                  marginBottom: 12,
                }}
              >

                <strong>
                  {banner.name}
                </strong>


                <label
                  style={{
                    display: 'flex',
                    alignItems:
                      'center',
                    gap: 7,
                    cursor:
                      'pointer',
                  }}
                >

                  <input
                    type="checkbox"
                    checked={
                      !!banner.is_active
                    }
                    onChange={() =>
                      toggleSiteBanner(
                        banner
                      )
                    }
                  />

                  {banner.is_active
                    ? 'Активен'
                    : 'Выключен'}

                </label>

              </div>


              <img
                src={`${API_ORIGIN}${banner.image_url}`}
                alt={banner.name}
                style={{
                  display: 'block',
                  width: '100%',
                  maxWidth: 650,
                  maxHeight: 350,
                  objectFit:
                    'contain',
                  borderRadius: 8,
                  marginBottom: 12,
                }}
              />


              <div
                style={{
                  marginBottom: 5,
                }}
              >
                <b>Ссылка:</b>{' '}

                {banner.link_url ||
                  'нет'}
              </div>


              <div
                style={{
                  marginBottom: 15,
                }}
              >
                <b>Кнопка:</b>{' '}

                {banner.button_text ||
                  'нет'}
              </div>


              <button
                type="button"
                className="admin-btn danger"
                onClick={() =>
                  deleteSiteBanner(
                    banner
                  )
                }
              >
                Удалить
              </button>

            </div>

          )
        )}

      </div>

    </div>
  );
}


  // ---------- РЕНДЕР ВСЕЙ АДМИНКИ ----------
  return role === 'superadmin' ? (
    <div
      className="admin-root"
      style={{
        minHeight: '100vh',
        boxSizing: 'border-box',
        backgroundColor: '#2c313d',
        color: '#ffffff',
      }}
    >
      <h1>Admin Panel</h1>

      <div className="admin-tabs">
        <button
          className={`admin-tab-btn ${
            activeTab === 'users' ? 'active' : ''
          }`}
          onClick={() => setActiveTab('users')}
        >
          Users
        </button>


        <button
  className={`admin-tab-btn ${
    activeTab === 'banners'
      ? 'active'
      : ''
  }`}
  onClick={() => {
    setActiveTab('banners');
    fetchSiteBanners();
  }}
>
  Баннеры
</button>


        <button
          className={`admin-tab-btn ${
            activeTab === 'wheel' ? 'active' : ''
          }`}
          onClick={() => setActiveTab('wheel')}
        >
          Колесо Удачи
        </button>


        <button
          className={`admin-tab-btn ${activeTab === 'support' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('support');
            fetchSupportThreads();  // при открытии сразу загрузим список
          }}
        >
          Поддержка
        </button>


        <button
          className={`admin-tab-btn ${activeTab === 'bots' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('bots');
            if (!botConfig) fetchBotSettings();
          }}
        >
          Боты
        </button>

        <button
          className={`admin-tab-btn ${
            activeTab === 'shortGames' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('shortGames');
            fetchShortGames(); // при переключении сразу грузим данные
          }}
        >
          Короткие кеш-игры
        </button>

                <button
          className={`admin-tab-btn ${
            activeTab === 'finance' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('finance');
            fetchFinanceTransactions(); // при открытии сразу грузим
          }}
        >
          Ввод / вывод
        </button>

           <button
          className={`admin-tab-btn ${
            activeTab === 'longGames' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('longGames');
            fetchLongGames(); // при переключении сразу грузим данные
          }}
        >
          Длинные кеш-игры
        </button>


        <button
  className={`admin-tab-btn ${activeTab === 'tournaments' ? 'active' : ''}`}
  onClick={() => {
    setActiveTab('tournaments');
    fetchTournamentsStats();
  }}
>
  Турниры (Sit&Go)
</button>

<button
  className={`admin-tab-btn ${
    activeTab === 'longTournaments' ? 'active' : ''
  }`}
  onClick={() => {
    setActiveTab('longTournaments');
    fetchLongTournamentsStats();
  }}
>
  Турниры (Long)
</button>

        <button
          className={`admin-tab-btn ${
            activeTab === 'pokerRake' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('pokerRake');
            fetchPokerRakeStats();
          }}
        >
          Покер (рейк)
        </button>


      </div>
     

      {activeTab === 'users' && (
        <div
          className="admin-section"
          style={{
            maxWidth: 980,
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 12,
              flexWrap: 'wrap',
              marginBottom: 14,
            }}
          >
            <h2 style={{ margin: 0 }}>
              Пользователи:
            </h2>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                flexWrap: 'wrap',
              }}
            >
              <span
                style={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: '#d7dde8',
                }}
              >
                Онлайн:{' '}
                {
                  Object.values(
                    presenceByUserId
                  ).filter(
                    (item) => item?.isOnline
                  ).length
                }
              </span>

              <button
                type="button"
                className="admin-btn"
                onClick={() => {
                  fetchUsers();
                  fetchPresence();
                }}
                disabled={presenceLoading}
              >
                {presenceLoading
                  ? 'Обновление...'
                  : 'Обновить статусы'}
              </button>
            </div>
          </div>

          {presenceError && (
            <div
              style={{
                color: '#fecaca',
                marginBottom: 12,
              }}
            >
              {presenceError}
            </div>
          )}

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 6,
            }}
          >
            {[...users]
              .sort((a, b) => {
                const aPresence =
                  presenceByUserId[
                    String(a.id)
                  ];

                const bPresence =
                  presenceByUserId[
                    String(b.id)
                  ];

                if (
                  !!aPresence?.isOnline !==
                  !!bPresence?.isOnline
                ) {
                  return aPresence?.isOnline
                    ? -1
                    : 1;
                }

                const aSeconds =
                  aPresence?.secondsAgo != null &&
                  Number.isFinite(
                    Number(
                      aPresence.secondsAgo
                    )
                  )
                    ? Number(
                        aPresence.secondsAgo
                      )
                    : Number.MAX_SAFE_INTEGER;

                const bSeconds =
                  bPresence?.secondsAgo != null &&
                  Number.isFinite(
                    Number(
                      bPresence.secondsAgo
                    )
                  )
                    ? Number(
                        bPresence.secondsAgo
                      )
                    : Number.MAX_SAFE_INTEGER;

                return aSeconds - bSeconds;
              })
              .map((u) => {
                const userPresence =
                  presenceByUserId[
                    String(u.id)
                  ];

                const isOnline =
                  !!userPresence?.isOnline;

                return (
                  <div
                    key={u.id}
                    className="admin-row"
                    style={{
                      display: 'grid',
                      gridTemplateColumns:
                        'minmax(180px, 1fr) auto auto',
                      alignItems: 'center',
                      gap: 10,
                      width: '100%',
                      minHeight: 36,
                      padding: '4px 0',
                    }}
                  >
                    <span
                      style={{
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow:
                          'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {u.username} ({u.role})
                    </span>

                    <span
                      style={getPresenceBadgeStyle(
                        isOnline
                      )}
                      title={
                        userPresence?.lastSeenAt
                          ? new Date(
                              userPresence.lastSeenAt
                            ).toLocaleString()
                          : ''
                      }
                    >
                      <span
                        aria-hidden="true"
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          background: isOnline
                            ? '#22c55e'
                            : '#94a3b8',
                        }}
                      />

                      {formatPresenceStatus(
                        userPresence
                      )}
                    </span>

                    <button
                      className="admin-btn danger"
                      onClick={() =>
                        banUser(u.id)
                      }
                    >
                      Ban
                    </button>
                  </div>
                );
              })}
          </div>
        </div>
      )}

      {activeTab === 'wheel' && <WheelOfFortuneTab />}
      {activeTab === 'banners' && SiteBannersTab()}
      {activeTab === 'bots' && <BotControlTab />}
      {activeTab === 'shortGames' && <ShortGamesTab />}
      {activeTab === 'longGames' && <LongGamesTab />}
      {activeTab === 'tournaments' && <TournamentStatsTab />}
      {activeTab === 'longTournaments' && <LongTournamentStatsTab />}
      {activeTab === 'pokerRake' && <PokerRakeTab />}
      {activeTab === 'finance' && <FinanceTransactionsTab />}
      {activeTab === 'support' && SupportTab()}

    </div>
  ) : null;
}

export default AdminPanel;


